import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import EthereumNetworkIcon from '../Icons/EthereumNetworkIcon';
import BinanceNetworkIcon from '../Icons/BinanceNetworkIcon';
import './TokenWithNetwork.scss';

const TokenWithNetwork = ({ token }) => {
  const NetowrkLogo = useMemo(() => {
    switch (token?.network?.toLowerCase()) {
      case 'ethereum':
        return EthereumNetworkIcon;

      case 'binance':
        return BinanceNetworkIcon;

      default:
        return BinanceNetworkIcon;
    }
  }, [token?.network]);

  const renderedImg = useMemo(() => {
    // not all tokens has valid imgs
    const possibleKeys = ['image', 'token_image_thumb', 'token_image_small', 'token_image_large'];
    const validKey = possibleKeys.find((key) => token?.[key]);
    return token?.[validKey];
  }, [token]);

  return (
    <div className="token-with-network-wrapper">
      <img className="token-image" src={renderedImg} alt={token?.symbol} />
      <NetowrkLogo />
    </div>
  );
};

TokenWithNetwork.propTypes = {
  token: PropTypes.object.isRequired,
};

export default TokenWithNetwork;
